export const OMR_REVIEWS_URL = 'https://omr.com/en/reviews/product/fiverr?utm_source=widget&utm_medium=vendor';
export const OMR_RATING_IMAGE_SRC =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/bed6f7429b12f8de5c766e5d9cd891bc-1772526716742/OMR-rating.png';
